import { cn } from "../shared/ui/index.ts";
import * as React from "react";
import { Interactions } from "../core/providers/interactions.provider.tsx";
import { I } from "../shared/icons/icons.tsx";
import { PatientNameDisplay } from "../shared/patient/patient-name-display.component.tsx";
import { formatPatientDisplayName } from "../shared/patient/patient-name.ts";
import {
  pg,
  pgBarActions,
  pgBarStart,
  accentBtnLg,
  secondaryBtnLg,
} from "../shared/page-layout.ts";
export function FirstContactPage() {
  const initial = [
    {
      id: 1,
      name: "Léa Moreau",
      phone: "06 12 34 56 78",
      source: "Doctolib",
      age: 34,
      when: "il y a 12 min",
      motif: "Consultation pour douleurs abdominales récurrentes",
      priority: "normal",
    },
    {
      id: 2,
      name: "Hugo Martin",
      phone: "07 98 76 54 32",
      source: "Téléphone",
      age: 45,
      when: "il y a 1 h",
      motif: "Demande devis traitement orthodontique",
      priority: "normal",
    },
    {
      id: 3,
      name: "Sarah Vidal",
      phone: "06 33 22 11 00",
      source: "Doctolib",
      age: 28,
      when: "il y a 3 h",
      motif: "Première consultation, recommandée par Dr. Lemaitre",
      priority: "high",
    },
    {
      id: 4,
      name: "Thomas Renard",
      phone: "07 55 66 77 88",
      source: "Site web",
      age: 52,
      when: "hier",
      motif: "Demande de second avis suite à un diagnostic",
      priority: "normal",
    },
  ];
  type ContactItem = (typeof initial)[number];
  const [items, setItems] = React.useState(initial);
  const toast = Interactions.useToast();
  const dialog = Interactions.useDialog();

  const handleCall = (p: ContactItem) => {
    toast.push({
      type: "info",
      title: `Appel de ${formatPatientDisplayName(p.name)}…`,
      message: p.phone,
    });
    setTimeout(() => {
      setItems((prev) => prev.filter((i) => i.id !== p.id));
      toast.push({
        type: "success",
        title: "Contact traité",
        message: `${formatPatientDisplayName(p.name)} retiré de la liste`,
      });
    }, 800);
  };
  const handleSchedule = (p: ContactItem) => {
    dialog.openNewRdv(p.name);
    setItems((prev) => prev.filter((i) => i.id !== p.id));
  };
  return (
    <div className={pg.page}>
      <div className={pg.toolbar}>
        <p
          className={cn(pgBarStart, "truncate text-[13px] text-sf-text-muted")}
        >
          <span className="font-bold text-sf-text">{items.length}</span>{" "}
          contacts à traiter ·{" "}
          <span className="font-semibold text-sf-danger">1 prioritaire</span>
        </p>
        <div className={pgBarActions}>
          <button type="button" className={secondaryBtnLg()}>
            <I.UserPlus size={14} /> Nouveau contact
          </button>
        </div>
      </div>
      <div className={cn(pg.content, pg.gridCards)}>
        {items.map((p) => (
          <div
            key={p.id}
            className="flex flex-col gap-3 rounded-lg border border-sf-border bg-white p-4 shadow-[var(--sf-shadow-sm)]"
          >
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="mb-0.5 flex items-center gap-2">
                  <PatientNameDisplay
                    name={p.name}
                    firstClassName="text-sm font-semibold"
                  />
                  {p.priority === "high" && (
                    <span className="rounded border border-red-200 bg-red-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-sf-danger">
                      Prioritaire
                    </span>
                  )}
                </div>
                <div className="text-xs text-sf-text-muted">
                  {p.age} ans · {p.phone}
                </div>
              </div>
              <span className="rounded border border-sf-border bg-sf-surface-alt px-[7px] py-0.5 text-[10.5px] font-semibold text-sf-text-secondary">
                {p.source}
              </span>
            </div>
            <div className="text-[12.5px] leading-snug text-sf-text-secondary">
              &quot;{p.motif}&quot;
            </div>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <div className="text-[11px] text-sf-text-muted">{p.when}</div>
              <div className="flex flex-col gap-1.5 sm:flex-row">
                <button
                  type="button"
                  onClick={() => handleCall(p)}
                  className={secondaryBtnLg()}
                >
                  Rappeler
                </button>
                <button
                  type="button"
                  onClick={() => handleSchedule(p)}
                  className={accentBtnLg()}
                >
                  Planifier RDV
                </button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="col-span-full p-[60px] text-center text-sm text-sf-text-muted">
            ✨ Plus aucun contact à traiter
          </div>
        )}
      </div>
    </div>
  );
}
